/**
 * Lecture automatique d'un reçu photo (IA) — partagé portail Entreprise / admin Entrepreneurs.
 * Le résultat pré-remplit le formulaire ; l'utilisateur vérifie avant d'enregistrer.
 */
import { useState } from "react";
import axios from "axios";
import { Loader2, ScanLine, X } from "lucide-react";
import { toast } from "@/lib/toast";

const IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

export function useReceiptScan(url, headers) {
  const [scanning, setScanning] = useState(false);
  const [result, setResult] = useState(null);

  const scan = async (file) => {
    if (!file || !IMAGE_TYPES.includes((file.type || "").toLowerCase())) { setResult(null); return null; }
    setScanning(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await axios.post(url, fd, { headers: headers() });
      setResult(r.data);
      return r.data;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Lecture automatique impossible — saisissez les montants");
      setResult(null);
      return null;
    } finally {
      setScanning(false);
    }
  };

  return { scan, scanning, result, clear: () => setResult(null) };
}

export function ScanBanner({ scanning, result, onClear, testId = "receipt-scan" }) {
  if (scanning) {
    return (
      <div className="flex items-center gap-2 text-xs bg-indigo-50 border border-indigo-200 text-indigo-800 rounded-lg px-3 py-2" data-testid={`${testId}-busy`}>
        <Loader2 className="w-4 h-4 animate-spin" /> Lecture du reçu en cours…
      </div>
    );
  }
  if (!result) return null;
  const pct = Math.round((result.confidence || 0) * 100);
  return (
    <div className="flex items-start gap-2 text-xs bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-lg px-3 py-2" data-testid={`${testId}-result`}>
      <ScanLine className="w-4 h-4 mt-0.5 shrink-0" />
      <div className="flex-1">
        <b>Reçu lu automatiquement</b> (confiance {pct} %) — vérifiez les champs avant d'enregistrer.
        {result.notes && <div className="text-emerald-800/80">{result.notes}</div>}
      </div>
      <button type="button" onClick={onClear} className="text-emerald-700 hover:text-emerald-900" aria-label="Fermer"><X className="w-4 h-4" /></button>
    </div>
  );
}
